import styled from 'styled-components'

import ListItem from './ListItem'

const List = styled.ul`
  list-style: none;
  margin: 0;

  display: flex;
  flex-direction: ${props => (props.inline ? 'row' : 'column')};
  flex-wrap: wrap;

  ${ListItem} {
    padding-right: ${props => (props.inline ? `${(props.theme.gutter * 2) / 3}px` : '')};
  }
`

export default List
